import MetaAppDrawer from './MetaAppDrawer';

const drawers = [MetaAppDrawer];

export default drawers;
